/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTeamCommand
 */
export interface CreateTeamCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateTeamCommand
     */
    name: string;
}

/**
 * Check if a given object implements the CreateTeamCommand interface.
 */
export function instanceOfCreateTeamCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function CreateTeamCommandFromJSON(json: any): CreateTeamCommand {
    return CreateTeamCommandFromJSONTyped(json, false);
}

export function CreateTeamCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTeamCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function CreateTeamCommandToJSON(value?: CreateTeamCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

